(function() {
  'use strict';

  function initMobileNavigation() {
    var existingDestroy = window.HibanaMotionMobileNavDestroy;

    if (typeof existingDestroy === 'function') {
      existingDestroy();
    }

    var root = document.documentElement;
    var cta = document.querySelector('.hibana-my-vehicle-mobile');
    var spacer = document.querySelector('.hibana-my-vehicle-mobile-spacer');
    var mediaQuery = window.matchMedia('(max-width: 1024px)');
    var lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var directionStartY = lastScrollY;
    var direction = 0;
    var hidden = false;
    var lastHeaderBottom = 0;
    var scrollFrame = 0;
    var metricsFrame = 0;
    var headerElements = [];
    var resizeObserver;
    var cleanup = [];

    if (!cta || !spacer) {
      window.HibanaMotionMobileNavDestroy = null;
      return;
    }

    function listen(target, eventName, handler, options) {
      target.addEventListener(eventName, handler, options);
      cleanup.push(function() {
        target.removeEventListener(eventName, handler, options);
      });
    }

    function listenToMedia(query, handler) {
      if (typeof query.addEventListener === 'function') {
        query.addEventListener('change', handler);
        cleanup.push(function() {
          query.removeEventListener('change', handler);
        });
      } else {
        query.addListener(handler);
        cleanup.push(function() {
          query.removeListener(handler);
        });
      }
    }

    function getHeaderElements() {
      var selectors = [
        '#shopify-section-announcement-bar',
        '#shopify-section-top-bar',
        '#shopify-section-header-inline',
        '#shopify-section-header-bottom',
        '#shopify-section-header-sidebar',
        '#shopify-section-header-categories-menu',
        '#shopify-section-header-vertical',
        '.t4s-section-header'
      ];
      var elements = [];

      selectors.forEach(function(selector) {
        document.querySelectorAll(selector).forEach(function(element) {
          if (elements.indexOf(element) === -1) {
            element.classList.add('hibana-mobile-nav-part');
            elements.push(element);
          }
        });
      });

      return elements;
    }

    function getTranslateY(element) {
      var transform = window.getComputedStyle(element).transform;
      var values;

      if (!transform || transform === 'none') {
        return 0;
      }

      if (transform.indexOf('matrix3d(') === 0) {
        values = transform.slice(9, -1).split(',');
        return parseFloat(values[13]) || 0;
      }

      if (transform.indexOf('matrix(') === 0) {
        values = transform.slice(7, -1).split(',');
        return parseFloat(values[5]) || 0;
      }

      return 0;
    }

    function getHeaderBottom(elements) {
      var bottom = 0;

      elements.forEach(function(element) {
        var style = window.getComputedStyle(element);
        var rect = element.getBoundingClientRect();
        var layoutBottom = rect.bottom - getTranslateY(element);

        if (style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && layoutBottom > 0) {
          bottom = Math.max(bottom, layoutBottom);
        }
      });

      return Math.max(0, Math.round(bottom));
    }

    function setNavMetrics(elements) {
      var announcement = document.querySelector('#shopify-section-announcement-bar');
      var announcementHeight = 0;
      var announcementStyle;
      var announcementRect;

      if (announcement) {
        announcementStyle = window.getComputedStyle(announcement);
        announcementRect = announcement.getBoundingClientRect();
        if (announcementStyle.display !== 'none' && announcementStyle.visibility !== 'hidden' && announcementRect.width > 0) {
          announcementHeight = Math.max(0, Math.round(announcementRect.height));
        }
      }

      root.style.setProperty('--hibana-mobile-announcement-height', announcementHeight + 'px');
      var headerBottom = getHeaderBottom(elements);
      var ctaHeight = Math.round(cta.offsetHeight || cta.getBoundingClientRect().height || 62);
      var hiddenOffset;

      if (headerBottom > 0) {
        lastHeaderBottom = headerBottom;
      } else {
        headerBottom = lastHeaderBottom;
      }

      hiddenOffset = Math.max(headerBottom + ctaHeight + 16, ctaHeight + 16);
      root.style.setProperty('--hibana-mobile-nav-top', headerBottom + 'px');
      root.style.setProperty('--hibana-mobile-cta-height', ctaHeight + 'px');
      root.style.setProperty('--hibana-mobile-nav-offset-negative', '-' + hiddenOffset + 'px');
    }

    function setHidden(nextHidden) {
      if (hidden === nextHidden) {
        return;
      }

      hidden = nextHidden;
      root.classList.toggle('hibana-mobile-nav-hidden', hidden);
      root.classList.toggle('hibana-mobile-nav-visible', !hidden);
    }

    function resetNav() {
      headerElements.forEach(function(element) {
        element.classList.remove('hibana-mobile-nav-part');
        element.style.removeProperty('transform');
      });
      root.classList.remove('hibana-mobile-nav-ready', 'hibana-mobile-nav-hidden', 'hibana-mobile-nav-visible');
      root.style.removeProperty('--hibana-mobile-nav-top');
      root.style.removeProperty('--hibana-mobile-cta-height');
      root.style.removeProperty('--hibana-mobile-nav-offset-negative');
      root.style.removeProperty('--hibana-mobile-announcement-height');
      cta.style.removeProperty('transform');
      hidden = false;
      direction = 0;
      directionStartY = lastScrollY;
    }

    function refreshMetrics() {
      metricsFrame = 0;

      if (!mediaQuery.matches) {
        if (resizeObserver) {
          resizeObserver.disconnect();
        }
        resetNav();
        return;
      }

      headerElements = getHeaderElements();
      if (resizeObserver) {
        headerElements.concat(cta).forEach(function(element) {
          resizeObserver.observe(element);
        });
      }
      setNavMetrics(headerElements);
      root.classList.add('hibana-mobile-nav-ready');
      root.classList.toggle('hibana-mobile-nav-visible', !hidden);
    }

    function syncScrollState() {
      var currentScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

      scrollFrame = 0;

      if (!mediaQuery.matches) {
        lastScrollY = Math.max(0, currentScrollY);
        return;
      }

      setHidden(false);
      direction = 0;
      directionStartY = currentScrollY;
      lastScrollY = Math.max(0, currentScrollY);
    }

    function requestScrollSync() {
      if (!scrollFrame) {
        scrollFrame = window.requestAnimationFrame(syncScrollState);
      }
    }

    function requestMetricsRefresh() {
      if (!metricsFrame) {
        metricsFrame = window.requestAnimationFrame(refreshMetrics);
      }
    }

    function destroy() {
      cleanup.forEach(function(removeListener) {
        removeListener();
      });
      cleanup = [];

      if (scrollFrame) {
        window.cancelAnimationFrame(scrollFrame);
      }
      if (metricsFrame) {
        window.cancelAnimationFrame(metricsFrame);
      }
      if (resizeObserver) {
        resizeObserver.disconnect();
      }

      resetNav();
      window.HibanaMotionMobileNavDestroy = null;
    }

    listen(window, 'load', requestMetricsRefresh);
    listen(window, 'resize', requestMetricsRefresh);
    listen(window, 'orientationchange', requestMetricsRefresh);
    listen(window, 'scroll', requestScrollSync, { passive: true });
    listenToMedia(mediaQuery, requestMetricsRefresh);

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(requestMetricsRefresh);
    }

    window.HibanaMotionMobileNavDestroy = destroy;
    refreshMetrics();
    syncScrollState();
    window.setTimeout(requestMetricsRefresh, 250);
  }

  function initBannerVideos(scope) {
    var context = scope || document;
    var banners = context.matches && context.matches('.banner-show-box-banner') ? [context] : Array.from(context.querySelectorAll('.banner-show-box-banner'));

    banners.forEach(function(banner) {
      if (banner.dataset.hibanaVideoInitialized === 'true') {
        return;
      }

      var videos = Array.from(banner.querySelectorAll('video.hibana-banner-video'));
      var viewportQuery = window.matchMedia('(min-width: 768px)');
      var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      var isVisible = true;
      var updateFrame = 0;
      var listeners = [];
      var visibilityObserver;
      var slideObserver;

      if (!videos.length) {
        return;
      }

      banner.dataset.hibanaVideoInitialized = 'true';

      function listen(target, eventName, handler) {
        target.addEventListener(eventName, handler);
        listeners.push(function() {
          target.removeEventListener(eventName, handler);
        });
      }

      function listenToMedia(query, handler) {
        if (typeof query.addEventListener === 'function') {
          query.addEventListener('change', handler);
          listeners.push(function() {
            query.removeEventListener('change', handler);
          });
        } else {
          query.addListener(handler);
          listeners.push(function() {
            query.removeListener(handler);
          });
        }
      }

      function isActiveSlide(video) {
        var slide = video.closest('.swiper-slide');
        var activeSlide;

        if (!slide) {
          return true;
        }

        activeSlide = slide.parentElement.querySelector('.swiper-slide-active');
        return activeSlide ? activeSlide === slide : slide === slide.parentElement.firstElementChild;
      }

      function updateVideos() {
        updateFrame = 0;

        videos.forEach(function(video) {
          var mediaContainer = video.closest('[data-hibana-banner-media]');
          var mode = mediaContainer ? mediaContainer.getAttribute('data-hibana-banner-media') : 'desktop';
          var matchesViewport = viewportQuery.matches ? mode === 'desktop' : mode === 'mobile';
          var shouldPlay = matchesViewport && isVisible && !document.hidden && !reducedMotionQuery.matches && isActiveSlide(video);

          if (shouldPlay) {
            video.preload = 'metadata';
            video.muted = true;
            video.loop = true;
            video.playsInline = true;

            if (video.paused) {
              var playRequest = video.play();
              if (playRequest && typeof playRequest.catch === 'function') {
                playRequest.catch(function() {});
              }
            }
          } else {
            video.pause();
            video.preload = 'none';
          }
        });
      }

      function scheduleUpdate() {
        if (!updateFrame) {
          updateFrame = window.requestAnimationFrame(updateVideos);
        }
      }

      function destroy() {
        listeners.forEach(function(removeListener) {
          removeListener();
        });
        if (visibilityObserver) {
          visibilityObserver.disconnect();
        }
        if (slideObserver) {
          slideObserver.disconnect();
        }
        if (updateFrame) {
          window.cancelAnimationFrame(updateFrame);
        }
        videos.forEach(function(video) {
          video.pause();
        });
        banner.removeAttribute('data-hibana-video-initialized');
      }

      listen(document, 'visibilitychange', scheduleUpdate);
      listenToMedia(viewportQuery, scheduleUpdate);
      listenToMedia(reducedMotionQuery, scheduleUpdate);

      if ('IntersectionObserver' in window) {
        visibilityObserver = new IntersectionObserver(function(entries) {
          isVisible = entries.some(function(entry) {
            return entry.isIntersecting;
          });
          scheduleUpdate();
        }, { rootMargin: '100px 0px', threshold: 0.05 });
        visibilityObserver.observe(banner);
      }

      if (banner.querySelectorAll('.swiper-slide').length > 1 && 'MutationObserver' in window) {
        slideObserver = new MutationObserver(scheduleUpdate);
        slideObserver.observe(banner, { attributes: true, attributeFilter: ['class'], subtree: true });
      }

      banner.hibanaVideoDestroy = destroy;
      updateVideos();
    });
  }

  function initParallax(scope) {
    var context = scope || document;
    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var elements = context.matches && context.matches('[data-hibana-parallax]') ? [context] : Array.from(context.querySelectorAll('[data-hibana-parallax]'));

    if (reducedMotionQuery.matches) {
      elements.forEach(function(element) {
        element.style.setProperty('--hibana-parallax-y', '0px');
      });
      return;
    }

    elements.forEach(function(element) {
      var active = false;
      var frame = 0;
      var observer;

      if (element.dataset.hibanaParallaxInitialized === 'true') {
        return;
      }

      element.dataset.hibanaParallaxInitialized = 'true';

      function update() {
        var rect = element.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var range = viewportHeight + rect.height;
        var progress = range ? (viewportHeight - rect.top) / range : 0.5;
        var clamped = Math.max(0, Math.min(1, progress));
        var amplitude = window.innerWidth < 768 ? 10 : 20;
        var offset = (clamped - 0.5) * amplitude * 2;

        frame = 0;
        element.style.setProperty('--hibana-parallax-y', offset.toFixed(2) + 'px');
      }

      function requestUpdate() {
        if (active && !frame) {
          frame = window.requestAnimationFrame(update);
        }
      }

      function destroy() {
        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
        if (observer) {
          observer.disconnect();
        }
        if (frame) {
          window.cancelAnimationFrame(frame);
        }
        element.removeAttribute('data-hibana-parallax-initialized');
        element.style.removeProperty('--hibana-parallax-y');
      }

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function(entries) {
          active = entries.some(function(entry) {
            return entry.isIntersecting;
          });
          requestUpdate();
        }, { rootMargin: '120px 0px', threshold: 0 });
        observer.observe(element);
      } else {
        active = true;
        requestUpdate();
      }

      element.hibanaParallaxDestroy = destroy;
    });
  }

  function init() {
    initMobileNavigation();
    initBannerVideos(document);
    initParallax(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initBannerVideos(event.target);
    initParallax(event.target);
    if (event.target.querySelector('.hibana-my-vehicle-mobile')) {
      initMobileNavigation();
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    var banners = event.target.matches('.banner-show-box-banner') ? [event.target] : Array.from(event.target.querySelectorAll('.banner-show-box-banner'));
    banners.forEach(function(banner) {
      if (typeof banner.hibanaVideoDestroy === 'function') {
        banner.hibanaVideoDestroy();
      }
    });
    var parallaxElements = event.target.matches('[data-hibana-parallax]') ? [event.target] : Array.from(event.target.querySelectorAll('[data-hibana-parallax]'));
    parallaxElements.forEach(function(element) {
      if (typeof element.hibanaParallaxDestroy === 'function') {
        element.hibanaParallaxDestroy();
      }
    });
  });
})();
